import axios from 'axios';

const TRANSALTE_URL = '/landing_page/translate_ugc';

export const translateUGC = async(UGC) =>
    axios.post(TRANSALTE_URL, { UGC })
        .then(({ data }) => data.translatedBlob);
